"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUscisFormMailingAddress = void 0;

var getUscisEmploymentEligibilityCategory_1 = require("./getUscisEmploymentEligibilityCategory");

var getUscisFormMailingAddress = function getUscisFormMailingAddress(_ref) {
  var isApplyingForAsylum = _ref.isApplyingForAsylum,
      wasAsylumApplicationApproved = _ref.wasAsylumApplicationApproved,
      isMailingWithUSPS = _ref.isMailingWithUSPS,
      state = _ref.state;
  // DETERMINE ELIGIBILITY CATEGORY
  // Determine eligibility category first so our logic can just match their chart
  // https://www.uscis.gov/i-765-addresses
  var eligibilityCategory = (0, getUscisEmploymentEligibilityCategory_1.getUscisEmploymentEligibilityCategory)({
    isApplyingForAsylum: isApplyingForAsylum,
    wasAsylumApplicationApproved: wasAsylumApplicationApproved
  }); // GET ADDRESS
  // --- (a)(5)

  if (eligibilityCategory === getUscisEmploymentEligibilityCategory_1.ELIGIBILITY_CATEGORIES.A_5) {
    if (["AZ", "CA", "MN", "OR", "PA"].includes(state)) {
      return isMailingWithUSPS ? {
        attention: "USCIS\nAttn: NFB",
        street1: "P.O. Box 21281",
        city: "Phoenix",
        state: "AZ",
        zipcode: "85036-1281"
      } : {
        attention: "USCIS\nAttn: NFB (Box 21281)",
        street1: "1820 E. Skyharbor Circle S",
        street2: "Suite 100",
        city: "Phoenix",
        state: "AZ",
        zipcode: "85034-4850"
      };
    }

    if (["NJ", "NY"].includes(state)) {
      return isMailingWithUSPS ? {
        attention: "USCIS\nAttn: NFB",
        street1: "P.O. Box 4115",
        city: "Carol Stream",
        state: "IL",
        zipcode: "60197-4115"
      } : {
        attention: "USCIS\nAttn: NFB (Box 4115)",
        street1: "2500 Westfield Drive",
        city: "Elgin",
        state: "IL",
        zipcode: "60124-7836"
      };
    }

    if (["IL", "IN", "IA", "MI", "MO", "OH", "WA", "WV", "WI"].includes(state)) {
      return isMailingWithUSPS ? {
        attention: "USCIS\nAttn: NFB",
        street1: "P.O. Box 805371",
        city: "Chicago",
        state: "IL",
        zipcode: "60680-5371"
      } : {
        attention: "USCIS\nAttn: NFB (Box 805371)",
        street1: "131 South Dearborn-3rd Floor",
        city: "Chicago",
        state: "IL",
        zipcode: "60603-5517"
      };
    }

    return isMailingWithUSPS ? {
      attention: "USCIS\nAttn: NFB",
      street1: "P.O. Box 660867",
      city: "Dallas",
      state: "TX",
      zipcode: "75266-0867"
    } : {
      attention: "USCIS\nAttn: NFB (Box 660867)",
      street1: "2501 S. State Hwy. 121 Business",
      street2: "Suite 400",
      city: "Lewisville",
      state: "TX",
      zipcode: "75067-8003"
    };
  } // --- (c)(8)


  if (eligibilityCategory === getUscisEmploymentEligibilityCategory_1.ELIGIBILITY_CATEGORIES.C_8) {
    return isMailingWithUSPS ? {
      attention: "USCIS\nAttn: I-765 C08",
      street1: "P.O. Box 650888",
      city: "Dallas",
      state: "TX",
      zipcode: "75265-0888"
    } : {
      attention: "USCIS\nAttn: I-765 C08 (Box 650888)",
      street1: "2501 S. State Hwy. 121 Business",
      street2: "Suite 400",
      city: "Lewisville",
      state: "TX",
      zipcode: "75067-8003"
    };
  } // --- ???


  return null;
};

exports.getUscisFormMailingAddress = getUscisFormMailingAddress;